import React from "react";
import { logoProps } from "./types";
import { Image } from "expo-image";

export default function FanRallyLogo(props: logoProps) {
  const { height = 100, width = 100 } = props;
  return (
    <Image
      {...props}
      source={{
        uri: "https://branding.fanrally.com/logos/fanrally_logo.svg",
      }}
      style={{ height, width }}
      contentFit="contain"
    />
  );
}
